// External Libraries
import React from "react";
import * as Icon from "react-feather";

// Services
import UtilityService from "../../../services/UtilityService";

// Common Components
import WComponent from "../../common/WComponent";

// Constants
import COMMUNICATIONS from "../../../constants/Communications";

const TYPE_ICONS = {
	meeting: <Icon.Video size={13} />,
	email: <Icon.Mail size={13} />,
	call: <Icon.Phone size={13} />,
	note: <Icon.FileText size={13} />,
};

class CommunicationCard extends WComponent {
	renderStatusBadge = status => {
		if (status === "done") return null;

		return <span className={`comm-card__status comm-card__status--${status}`}>{COMMUNICATIONS.statusLabels[status] || status}</span>;
	};

	render() {
		let { communication, onClick } = this.props;
		let { type, subject, occurred_at, participants, status, drive_file_url, summary } = communication;

		const dateLabel = UtilityService.formatDate({ value: occurred_at });
		const participantList = Array.isArray(participants) ? participants : [];

		return (
			<div className="comm-card" onClick={onClick}>
				<div className="comm-card__header">
					<div className="comm-card__header__left">
						<span className={`comm-card__type comm-card__type--${type}`}>
							{TYPE_ICONS[type]}
							{COMMUNICATIONS.typeLabels[type] || type}
						</span>

						</div>

					<div className="comm-card__date">{dateLabel}</div>
				</div>

				{subject && <div className="comm-card__subject">{subject}</div>}

				{participantList.length > 0 && (
					<div className="comm-card__participants">
						<Icon.Users size={12} />
						<span>{participantList.map(p => p.name || p.email).join(", ")}</span>
					</div>
				)}

				{this.renderStatusBadge(status)}

				{status === "done" && summary && (
					<div className="comm-card__summary">
						{summary.category && <div className="comm-card__category">{summary.category}</div>}

						<div className="comm-card__summary__text">{summary.summary}</div>

						{Array.isArray(summary.action_items) && summary.action_items.length > 0 && (
							<div className="comm-card__action-items">
								<div className="comm-card__action-items__label">Action Items</div>
								<ul className="comm-card__action-items__list">
									{summary.action_items.map((item, i) => (
										<li key={i}>{item}</li>
									))}
								</ul>
							</div>
						)}
					</div>
				)}

				{drive_file_url && (
					<div
						className="comm-card__drive-link"
						onClick={e => {
							e.stopPropagation();
							window.open(drive_file_url, "_blank");
						}}
					>
						<Icon.ExternalLink size={13} />
						View Full Notes in Drive
					</div>
				)}
			</div>
		);
	}
}

export default CommunicationCard;
